import React from 'react'
import { Setters } from 'src/features/yellStory/Components'
import { OrderPageTemplate } from 'src/Components/Domain/OrderPageTemplate'
import { infieldReducer, initialInfielderState } from 'src/features/yellStory/reducer/infielder'
import { State, PartialAction } from 'src/types'
import { BaseModelSelector } from 'src/Components/Domain/BaseModelSelector'
import { ysrGoldLineBaseModel as models } from 'src/features/yellStory/constants/baseModel'
import { SET_FIGURE_PANEL_NUMBER } from 'src/features/yellStory/constants/actionType'
import { useLocale } from 'src/locales/useLocale'

const YellStoryInfield: React.FC = () => {
  const [state, dispatch] = React.useReducer(infieldReducer, initialInfielderState) as [State, React.Dispatch<PartialAction>]
  const { figurePanelNum } = state
  const { t } = useLocale()
  const handleFigurePanelNum = (_, newValue: 0 | 1) => dispatch({ ...state, type: SET_FIGURE_PANEL_NUMBER, figurePanelNum: newValue })
  return (
    <OrderPageTemplate breadcrumbTrail={t.BREAD_CRUMB_TRAIL_YSR} brand={'yellStory'} {...{ figurePanelNum, state, dispatch, handleFigurePanelNum }}>
      <BaseModelSelector {...{ state, models, dispatch }} />
      <Setters {...{ state, figurePanelNum, dispatch }} />
    </OrderPageTemplate>
  )
}

export default YellStoryInfield
